/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { unionService } from '../../_services/union.service'
import Modal from 'react-responsive-modal'
import PicUploaderLiner from '../Shared/PicUploaderLiner'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { Input } from 'antd'
import Checkbox from '../Shared/Checkbox'
import FormikCheckbox from '../Shared/FormikCheckbox'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

function convertToFormData(params) {
  return Object.entries(params).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v, k) => acc.append(`${key}[${k}]`, value))
    } else if (
      typeof value === 'object' &&
      !(value instanceof File) &&
      !(value instanceof Date)
    ) {
      Object.entries(value).forEach((v, k) => acc.append(`${key}[${k}]`, value))
    } else {
      acc.append(key, value)
    }

    return acc
  }, new FormData())
}

class Union extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      initialItems: [],
      data: [],
      modal: false,
      modalHeading: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      model: { name: '', mode: '' },
      pageSize: 0
    }

    this.getData()
  }

  handleModalCreate = () => {
    this.setState({
      modalHeading: 'ثبت اتحادیه جدید',
      modal: true,
      model: { name: '', tels: '', mobile: '', address: '' }
    })
  }

  handleModalEdit = e => {
    let _model = this.state.data[e.target.dataset.index]
    // console.log(_model);

    this.setState({
      modal: true,
      model: _model,
      modalHeading: 'ویرایش اتحادیه "' + _model.name + '"'
    })
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  getData() {
    unionService
      .getAll()
      .then(res => {
        // console.log(res.data)
        var data = res.data
        var pageSize = data.length > 10 ? 10 : data.length
        this.setState({
          initialItems: data,
          pageSize: pageSize,
          data: data,
          loading: false,
          isSubmitting: false,
          modal: false
        })
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = e => {
    let _model = this.state.data[e.target.dataset.index]

    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })

    unionService
      .delete(this.state.model.id)
      .then(res => {
        toastr.success('حذف اتحادیه', 'اتحادیه با موفقیت حذف شد')
        this.getData()
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleSubmit = values => {
    this.setState({ loading: true })
    // console.log(values);

    if (values.id) {
      // values["imagePath"] = undefined;
      values['username'] = undefined
      values['password'] = undefined
      values['changePassword'] = false
      values['createDate'] = undefined
      if (!values.image) {
        values['image'] = ''
      }

      // console.log(JSON.stringify(values));
      // var formData = convertToFormData(values)
      unionService
        .edit(JSON.stringify(values))
        .then(res => {
          toastr.success(
            'ویرایش اتحادیه',
            'اتحادیه "' + values.name + '" با موفقیت ویرایش شد'
          )
          this.setState({ modal: false })
          this.getData()
        })
        .catch(error => {
          this.handleError(error)
        })
    } else {
      values['isActive'] = true
      // console.log(JSON.stringify(values));
      // var formData = convertToFormData(values)
      unionService
        .add(JSON.stringify(values))
        .then(res => {
          toastr.success(
            'ثبت اتحادیه جدید',
            'اتحادیه "' + values.name + '" با موفقیت ثبت شد'
          )
          this.setState({ modal: false })
          this.getData()
        })
        .catch(error => {
          this.handleError(error)
        })
    }
  }

  render() {
    const ValidationSchema = Yup.object().shape({
      name: Yup.string()
        .trim()
        .required('نام اتحادیه'),
      tels: Yup.string()
        .trim()
        .required('تلفن'),
      mobile: Yup.string()
        .trim()
        .required('موبایل'),
      address: Yup.string()
        .trim()
        .required('آدرس')
    })
    const { model, loading, data } = this.state
    return (
      !loading && (
        <div>
          <div className="row table-container" style={{ marginTop: 0 }}>
            <ReactTable
              data={data}
              filterable
              previousText="صفحه قبل"
              nextText="صفحه بعد"
              loadingText="در حال بارگذاری ..."
              noDataText="نتیجه ای یافت نشد"
              pageText="صفحه"
              ofText="از"
              rowsText="تعداد نمایش"
              getTableProps={() => ({ style: { display: 'block' } })}
              defaultFilterMethod={(filter, row) =>
                String(row[filter.id]) === filter.value
              }
              columns={[
                {
                  Header: 'ردیف',
                  id: 'row',
                  maxWidth: 50,
                  filterable: false,
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  className: 'numberFa',
                  Cell: row => {
                    return row.index + 1
                  }
                },
                {
                  Header: 'نام اتحادیه',
                  accessor: 'name',
                  id: 'name',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ['name'] }),
                  filterAll: true,
                  Filter: ({ onChange }) => (
                    <Input
                      placeholder=""
                      allowClear
                      onChange={event => onChange(event.target.value)}
                    />
                  )
                },
                {
                  Header: 'تلفن',
                  accessor: 'tels',
                  id: 'tels',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ['tels'] }),
                  filterAll: true,
                  Filter: ({ onChange }) => (
                    <Input
                      placeholder=""
                      allowClear
                      onChange={event => onChange(event.target.value)}
                    />
                  )
                },
                {
                  Header: 'موبایل',
                  accessor: 'mobile',
                  id: 'mobile',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ['mobile'] }),
                  filterAll: true,
                  Filter: ({ onChange }) => (
                    <Input
                      placeholder=""
                      allowClear
                      onChange={event => onChange(event.target.value)}
                    />
                  )
                },
                {
                  Header: 'ویرایش',
                  accessor: 'id',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  sortable: false,
                  // filterable: false,
                  Filter: ({ filter, onChange }) => (
                    <a
                      onClick={this.handleModalCreate}
                      className="btn btn-primary react-table-add-btn">
                      <i className="mdi mdi-plus" />
                      افزودن اتحادیه جدید
                    </a>
                  ),
                  Cell: row => (
                    <div>
                      <a
                        onClick={this.handleModalEdit}
                        data-index={row.index}
                        className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn"
                        rel="tooltip"
                        data-original-title="ویرایش">
                        <i data-index={row.index} className="mdi mdi-pencil" />
                      </a>

                      <a
                        onClick={this.handleDelete}
                        data-index={row.index}
                        className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn"
                        data-original-title="حذف"
                        rel="tooltip">
                        <i data-index={row.index} className="mdi mdi-delete" />
                      </a>
                    </div>
                  )
                }
              ]}
              key={this.state.pageSize}
              defaultPageSize={this.state.pageSize}
              className="-striped -highlight"
            />
          </div>
          <Modal
            open={this.state.modal}
            onClose={this.handleModalHide}
            center
            classNames={{
              overlay: 'customOverlay',
              modal: 'customModal lg',
              closeButton: 'customModalCloseButton'
            }}>
            <Formik
              initialValues={model}
              onSubmit={(values, { setSubmitting }) => {
                // console.log(values);
                this.handleSubmit(values)
              }}
              validationSchema={ValidationSchema}>
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit
                } = props
                return (
                  <div className="row" style={{ position: 'relative' }}>
                    <div className="col-md-12">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="form-inline">
                            <div className="col-md-12">
                              <label className="pull-right">نام اتحادیه</label>
                              <Field
                                type="text"
                                autoFocus
                                name="name"
                                className={
                                  getIn(errors, 'name') &&
                                  getIn(touched, 'name')
                                    ? 'text-input has-error rtl'
                                    : 'text-input required rtl'
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="name"
                              />
                            </div>

                            <div className="col-md-6">
                              <label className="pull-right">تلفن</label>
                              <Field
                                type="text"
                                name="tels"
                                className={
                                  getIn(errors, 'tels') &&
                                  getIn(touched, 'tels')
                                    ? 'text-input has-error rtl'
                                    : 'text-input required rtl'
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="tels"
                              />
                            </div>

                            <div className="col-md-6">
                              <label className="pull-right">موبایل</label>
                              <Field
                                type="text"
                                name="mobile"
                                className={
                                  getIn(errors, 'mobile') &&
                                  getIn(touched, 'mobile')
                                    ? 'text-input has-error rtl'
                                    : 'text-input required rtl'
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="mobile"
                              />
                            </div>

                            <div className="col-md-12">
                              <label className="pull-right">آدرس</label>
                              <Field
                                name="address"
                                rows="10"
                                render={({ field }) => (
                                  <textarea
                                    {...field}
                                    value={values.address}
                                    className={
                                      getIn(errors, 'address') &&
                                      getIn(touched, 'address')
                                        ? 'textarea has-error rtl'
                                        : 'textarea required rtl'
                                    }
                                  />
                                )}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="address"
                              />
                            </div>

                            <div className="col-md-12">
                              <label className="pull-right" />
                              <Field
                                component={FormikCheckbox}
                                name="creditPayment"
                                value={values.creditPayment}
                                id="creditPayment"
                                label={'عدم نیاز به پرداخت آنلاین'}
                              />
                            </div>

                            {!values.id && (
                              <div className="col-md-6">
                                <label className="pull-right">نام کاربری</label>
                                <Field
                                  type="text"
                                  name="username"
                                  className={
                                    getIn(errors, 'username') &&
                                    getIn(touched, 'username')
                                      ? 'text-input has-error rtl'
                                      : 'text-input required rtl'
                                  }
                                />
                                <ErrorMessage
                                  component={ErrorPopUp}
                                  name="username"
                                />
                              </div>
                            )}
                            {!values.id && (
                              <div className="col-md-6">
                                <label className="pull-right">رمز ورود</label>
                                <Field
                                  type="password"
                                  name="password"
                                  className={
                                    getIn(errors, 'password') &&
                                    getIn(touched, 'password')
                                      ? 'text-input has-error rtl'
                                      : 'text-input required rtl'
                                  }
                                />
                                <ErrorMessage
                                  component={ErrorPopUp}
                                  name="password"
                                />
                              </div>
                            )}
                            {/* <div className="col-md-12">
                                                        <label className="pull-right">تصویر</label>
                                                        <PicUploaderLiner label="تصویر"
                                                            value={values.imagePath}
                                                            onChange={(val) => {
                                                                // console.log(val);
                                                                setFieldValue('image', val);
                                                            }}
                                                        />
                                                        <ErrorMessage component={ErrorPopUp} name="image" />
                                                    </div> */}

                            <div className="col-md-12">
                              <br />
                              <input
                                type="hidden"
                                name="id"
                                value={values.id}
                              />
                              <button
                                type="submit"
                                className={
                                  'icon button submit-btn ' +
                                  (isSubmitting ? 'isSubmitting' : '')
                                }
                                disabled={isSubmitting}>
                                ذخیره
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )
              }}
            </Formik>
          </Modal>

          <MySweetAlert
            show={this.state.confirmDeleteShow}
            onCancel={this.handleSweetAlertHide}
            onConfirm={this.handleConfirmDelete}
            title={
              'آیا از حذف اتحادیه [' + this.state.model.name + '] مطمئن هستید؟'
            }
          />
          {this.state.loading ? <Loading /> : ''}
        </div>
      )
    )
  }
}

export default Union
